<template>
  <div id="app" v-cloak ref="appRef">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import appMixin from '@/mixins/appMixin';

export default {
  name: 'app',
  mixins: [appMixin],
  async created() {
    this.$store.commit('themeAndLanguage/initTheme');
    this.$store.commit('themeAndLanguage/initThemeType');
    await this.$store.dispatch('common/getSystemSetInfo');
  },
};
</script>
